import axios from "const/axios";

const base = (studentId) => `student/${studentId}/workflow`;

// Steps
export const getAdmissionSteps = (studentId, token) =>
  axios.get(`${base(studentId)}/steps`, { headers: { Authorization: `Bearer ${token}` } });

export const saveAdmissionStepData = (studentId, stepNumber, stepData, token) =>
  axios.put(
    `${base(studentId)}/steps/${stepNumber}`,
    { stepData: JSON.stringify(stepData) },
    { headers: { Authorization: `Bearer ${token}` } }
  );

export const completeAdmissionStep = (studentId, stepNumber, token) =>
  axios.post(
    `${base(studentId)}/steps/${stepNumber}/complete`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );

export const uncompleteAdmissionStep = (studentId, stepNumber, token) =>
  axios.post(
    `${base(studentId)}/steps/${stepNumber}/uncomplete`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );

// Documents
export const getAdmissionDocuments = (studentId, stepNumber, token) => {
  const params = stepNumber != null ? { step: stepNumber } : {};
  return axios.get(`${base(studentId)}/documents`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const addAdmissionDocument = (studentId, stepNumber, documentName, fileUrl, token) =>
  axios.post(`${base(studentId)}/documents`, null, {
    params: { stepNumber, documentName, fileUrl },
    headers: { Authorization: `Bearer ${token}` },
  });

export const deleteAdmissionDocument = (studentId, documentId, token) =>
  axios.delete(`${base(studentId)}/documents/${documentId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

// File upload (reuses existing endpoint)
export const uploadFile = (file, token) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post("file/upload", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};
